import { useEffect, useState } from "react";
import { Dialog, DialogContent, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import sorteo from "../../assets/images/sorteo.jpg";

function PopupAviso() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const hoy = new Date();

    const fechaInicio = new Date("2026-06-19");
    const fechaFin = new Date("2026-08-30T23:59:59");

    if (hoy >= fechaInicio && hoy <= fechaFin) {
      setOpen(true);
    }
  }, []);

  return (
    <Dialog open={open} onClose={() => setOpen(false)} maxWidth="md" fullWidth>
      <IconButton
        onClick={() => setOpen(false)}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
          zIndex: 1,
        }}
      >
        <CloseIcon />
      </IconButton>

      <DialogContent sx={{ p: 0 }}>
        <img
          src={sorteo}
          alt="Aviso Importante"
          style={{
            width: "100%",
            display: "block",
          }}
        />
      </DialogContent>
    </Dialog>
  );
}

export default PopupAviso;
